// extracted by mini-css-extract-plugin
module.exports = {"root":"Tools_root__XV_2y","root_title":"Tools_root_title__4aDYR"};